<template>
  <div class="pb-16 md:pb-0">
    <div class="flex items-center justify-center">
      <div class="md:text-center space-y-3 max-w-md md:max-w-lg max-w">
        <BaseText type="display" size="2xs">
          <h4>
            Test one plan 7 days for free
          </h4>
        </BaseText>
        <BaseText size="md" class="text-neutral-alpha-650">
          Choose a plan and start your free 7-day trial. Find your next winning ad, and level up your workflow for free without any risk.
        </BaseText>
      </div>
    </div>
    <!-- Monthly-only trials: interval selector hidden. Restore this block to re-enable annual. -->
    <!--
    <div class="mt-7 mb-4 md:mt-10 md:mb-10 w-full flex items-center justify-center">
      <div ref="intervalContainer" class="w-full md:w-auto relative rounded-lg flex items-center gap-2 p-0.5 border border-neutral-alpha-300 max-w-md">
        <div :style="backgroundStyle" class="absolute z-10 rounded-lg transition-all selected-interval-tag" />
        <button ref="monthly-btn" class="w-1/2 md:w-auto px-2 py-1.5 rounded-lg z-20 transition-colors"
        @click="setInterval('monthly')">
          <BaseText type="label" size="sm" :class="activeInterval === 'monthly' ? 'text-white' : 'text-neutral-alpha-400'">
            Monthly
          </BaseText>
        </button>
        <button ref="annual-btn" class="w-1/2 md:w-auto px-2 py-1.5  z-20 transition-colors flex items-center gap-2 justify-center md:justify-start flex-nowrap whitespace-nowrap"
        @click="setInterval('annual')">
          <BaseText type="label" size="sm" :class="activeInterval === 'annual' ? 'text-white' : 'text-neutral-alpha-400'">
            Annually
          </BaseText>
          <BaseText size="sm" :class="activeInterval === 'annual' ? 'text-white' : 'text-neutral-alpha-400'">
            Save ~15%
          </BaseText>
        </button>
      </div>
    </div>
    -->
    <div class="flex flex-col gap-y-3 gap-x-3 md:flex-row md:items-start md:justify-center md:gap-[15px] w-full mt-7 mb-4 md:mt-10 md:mb-10">
      <DarkProductCard
        style="width: 100%; max-width: 461px;"
        v-for="plan in productCards"
        :key="plan.key"
        :product="plan"
        :is-monthly="true"
        :all-products="PRODUCT_ASSETS"
        :active-interval="activeInterval"
        @action="handleNext"
      />
    </div>
  </div>
</template>

<script>
import posthog from 'posthog-js'
import MoneyCircleIcon from '@/components/globals/Icons/MoneyCircleIcon.vue'
import { SUBSCRIPTION_PLANS, PRODUCT_ASSETS, ENTERPRISE_BENEFITS, TRUSTED_COMPANIES } from '@/utils/stripe/productMeta'
import DarkProductCard from '@/components/account/subscription/DarkProductCard.vue'
// Icons
import ChevronIcon from '@/components/globals/Icons/ChevronIcon.vue'
import CheckmarkIcon from '@/components/globals/Icons/CheckmarkIcon.vue'
export default {
  components: {
    MoneyCircleIcon,
    DarkProductCard,
    ChevronIcon,
    CheckmarkIcon
  },
  data () {
    return {
      PRODUCT_ASSETS,
      ENTERPRISE_BENEFITS,
      TRUSTED_COMPANIES,
      // Monthly-only trials: keep locked to monthly. Restore selector to allow annual again.
      activeInterval: 'monthly',
      backgroundStyle: {},
      resizeObserver: null,
      useMobileLayout: window.innerWidth < 768
    }
  },
  computed: {
    productCards () {
      if (!this.useMobileLayout) return SUBSCRIPTION_PLANS
      // Reorder the plans to put basic last in mobile layout
      return [SUBSCRIPTION_PLANS[1], SUBSCRIPTION_PLANS[2], SUBSCRIPTION_PLANS[0]]
    }
  },
  mounted(){
    posthog.capture('Pricing Viewed', {
      $current_url: window.location.href
    })
    // Monthly-only trials: interval selector is hidden.
    // this.setInterval(this.activeInterval)
    window.addEventListener('resize', this.handleWindowResize)
    // Monthly-only trials: interval selector is hidden, so skip measuring the toggle.
    // this.$nextTick(() => {
    //   this.resizeObserver = new ResizeObserver(() => {
    //     this.setInterval(this.activeInterval)
    //   })
    //   this.resizeObserver.observe(this.$refs.intervalContainer)
    // })
  },
  beforeDestroy () {
    if (this.resizeObserver) this.resizeObserver.disconnect()
    window.removeEventListener('resize', this.handleWindowResize)
  },
  methods: {
    handleNext (payload) {
      posthog.capture('Checkout Started', {
        plan: payload.name,
        interval: payload.interval,
        price: payload.price,
        priceId: payload.priceId
      })
      this.$emit('next', { step: 'plan', data: payload })
    },
    handleWindowResize () {
      this.useMobileLayout = window.innerWidth < 768
    },
    setInterval(key) {
      this.activeInterval = key;
      this.$nextTick(() => {
        const activeBtn = this.$refs?.[`${this.activeInterval}-btn`];
        const container = this.$refs.intervalContainer;
        if (activeBtn && container) {
          const btnRect = activeBtn.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          this.backgroundStyle = {
            left: `${btnRect.left - containerRect.left}px`,
            top: `${btnRect.top - containerRect.top - 1}px`,
            width: `${btnRect.width}px`,
            height: `${btnRect.height}px`,
          };
        }
      });
    },
  }
}
</script>

<style scoped>
.base-btn-dark{
  background-color: rgba(255,255,255,0.1);
  border-radius: 10px;
  color: #fff;
  transition: background-color 100ms ease-in-out;
}

.base-btn-dark:hover {
  background-color: rgba(255,255,255,0.16);
}

.money-icon {
  color: #EBBE7A
}

.selected-interval-tag {
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.10);
}
</style>
